import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { IuaHistorical } from 'src/app/services/api/ftth/ftth.service';

@Component({
  selector: 'app-iua-historical',
  templateUrl: './iua-historical.component.html',
  styleUrls: ['./iua-historical.component.scss']
})
export class IuaHistoricalComponent implements OnInit {

  title = 'Histórico de IUAs';
  historico: string[];
  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    this.historico = data.historico;
  }

  ngOnInit() {
  }

}
